<template>
  <header class="main-header">
    <router-link
      :to="{name: 'dashboard'}"
      class="logo"
    >
      <span class="logo-mini"><b>CH </b>Hero</span>
      <span class="logo-lg"><b>{{ appName }} </b></span>
    </router-link>

    <nav class="navbar navbar-static-top">
      <a
        href="javascript:void(0)"
        class="sidebar-toggle"
        data-toggle="push-menu"
        role="button"
      >
        <span class="sr-only">Toggle navigation</span>
      </a>
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li class="dropdown tasks-menu">
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              @click="onChangeLocale"
              data-toggle="dropdown"
            >
              <img
                :src="`/img/flags/${flag}.png`"
                style="height: 16px;"
                alt="Flag"
              >
            </a>
          </li>

          <li class="dropdown user user-menu">
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
            >
              <img
                :src="userAvatar"
                class="user-image"
                alt="User Image"
                @error="(e) => {e.target.src='/img/avatar.png'}"
              >
              <span
                class="hidden-xs"
                v-if="currentUser"
              >{{ currentUser.name }}</span>
            </a>
            <ul class="dropdown-menu">
              <li
                class="user-header"
                v-if="currentUser"
              >
                <img
                  :src="userAvatar"
                  class="img-circle"
                  alt="User Image"
                  @error="(e) => {e.target.src='/img/avatar.png'}"
                >
                <p>
                  {{ currentUser.name || 'Unknown' }} - {{ currentUser.id_card || $t('string.na') }}
                  <small>{{ currentUser.created_at }}</small>
                </p>
              </li>
              <li class="user-footer">
                <div class="pull-left">
                  <router-link
                    :to="{name: 'Profile'}"
                    class="btn btn-default btn-flat"
                  >
                    {{ $t('user.profile') }}
                  </router-link>
                </div>
                <div class="pull-right">
                  <a
                    href="javascript:void(0)"
                    @click="signOut"
                    class="btn btn-default btn-flat"
                  >{{ $t('user.signOut') }}</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  data () {
    return {
      appName: process.env.VUE_APP_NAME,
      locale: this.$i18n.locale,
      apiUrl: process.env.VUE_APP_API
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    flag () {
      return this.$i18n.locale === 'en' ? 'km' : 'en'
    }
  },
  methods: {
    onChangeLocale () {
      let locale = 'en'
      if (this.$i18n.locale === 'en') {
        locale = 'km'
      }
      this.$i18n.locale = locale
      this.$axios.defaults.headers.common['X-localization'] = locale
      localStorage.setItem('locale', locale)
    },
    signOut () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/auth/backend/logout')
        .finally(() => {
          this.$isLoading(false)
          localStorage.removeItem(process.env.VUE_APP_TOKEN)
          localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN)
          this.$store.dispatch('user/clearUser')
          this.$router.push({ name: 'login' })
        })
    }
  }
}
</script>
